export class EntityKey {

  entityType!: string;
  entityId!: string;
  entityRevision!: string;

}
